import React from 'react';
import { Typography, Alert } from '@one-thd/sui-atomic-components';
import { STATE_CODE_TO_NAME_MAP, US_TERRITORIES } from '@src/constants/general';
import { LORP_UNRECOGNIZED_ADDRESS_MESSAGE } from '@src/constants/analytics';
import { IErrorReturnService } from '@src/models/errors';
import ErrorBanner from '@src/components/shared/ErrorBanner';

interface LORPContactFormAlertsProps {
  isSTH?: boolean;
  stateCode?: keyof typeof STATE_CODE_TO_NAME_MAP;
  addressValidationErrorResponse?: Error | IErrorReturnService | null;
  zipCodeValidationError?: Error | IErrorReturnService | null;
  unconfirmedAddress: boolean;
}
// Notifies user of any limitations/restrictions that may apply to the LORP order depending on the fulfillment type
export const LORPContactFormAlerts = ({
  isSTH,
  stateCode,
  addressValidationErrorResponse,
  zipCodeValidationError,
  unconfirmedAddress,
}: LORPContactFormAlertsProps) => {
  const stateName = stateCode && STATE_CODE_TO_NAME_MAP[stateCode];
  const isTerritory = US_TERRITORIES.has(stateCode || '');

  const showError =
    addressValidationErrorResponse &&
    'code' in addressValidationErrorResponse &&
    (addressValidationErrorResponse as IErrorReturnService).code !==
      'VALIDATE_ADDRESS_REQUEST_BAD_INPUT_ADDRESS';
  return (
    <>
      {isSTH && (
        <Alert status="info" size="large">
          <Typography variant="body-base">
            If you&apos;d like to change your return pickup address, please call
            1-800-430-3376
          </Typography>
        </Alert>
      )}
      {!isSTH && (
        <Alert status="info" size="large">
          <Typography variant="body-base">
            {`Please enter a pickup address located in the ${
              isTerritory ? 'territory' : 'state'
            } of ${stateName}.`}
          </Typography>
        </Alert>
      )}
      {(showError || zipCodeValidationError) && <ErrorBanner />}
      {unconfirmedAddress && (
        <div className="sui-mt-6">
          <Alert status="warning" size="large">
            <Typography variant="body-base">
              {LORP_UNRECOGNIZED_ADDRESS_MESSAGE}
            </Typography>
          </Alert>
        </div>
      )}
    </>
  );
};
